import React from 'react';
import { View, StyleSheet, Text, TouchableOpacity } from 'react-native';

import Icon from 'shared/modules/common/components/atoms/Icon';
import generateID from 'shared/modules/common/utils/generate-id';

type Props = {
  icon: any;
  text: string;
  value: string;
  isAmount?: boolean;
  amountTestID: string;
  disabled?: boolean;
  onPress?: () => void;
};

const COLOR_PINK = '#e5258c';
const COLOR_GREY_DARK = '#2a2e32';

export default function AmountRow({
  icon,
  text,
  value,
  isAmount = true,
  amountTestID,
  disabled = true,
  onPress,
}: Props) {
  return (
    <TouchableOpacity
      disabled={disabled}
      onPress={onPress}
      style={styles.container}
      {...generateID(amountTestID)}
    >
      <View style={[styles.col, { justifyContent: 'flex-start' }]}>
        {icon}
        <Text style={styles.fontCaption02}>{text}</Text>
      </View>
      <View style={styles.col}>
        <Text
          style={[
            isAmount ? styles.fontBodyBold : styles.fontCaption01,
            { color: !disabled ? COLOR_PINK : COLOR_GREY_DARK },
          ]}
        >
          {value}
        </Text>
        {!disabled && <Icon name="caret-right-light" size="24" />}
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  col: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 34,
  },
  fontBodyBold: {
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 24,
    color: '#2a2e32',
  },
  fontCaption01: {
    fontSize: 13,
    fontWeight: 'bold',
    lineHeight: 16,
    color: '#2a2e32',
  },
  fontCaption02: {
    fontSize: 13,
    fontWeight: '300',
    lineHeight: 16,
    color: '#2a2e32',
  },
});
